export const getYearByMonth = (periode: number): number => periode / 12;

export const getDisplayPeriod = (periode: number): number => periode;